import { useState } from 'react'

import { shipmentStatuses, useFetch } from '@reveni-io/reveni-ui'

import commonServices from '@/common/services/services'
import { isTrackingParcel } from '@/parcels/helpers/helpers'
import parcelServices from '@/parcels/services/services'

const useCarrierService = ({ storeId, parcelId, refetchParcel, setToastInfo, parcel }) => {
  const { data: carrierServices, loading: loadingCarrierServices } = useFetch(
    () => commonServices.getCarrierServices({ storeId, type: 'shipment' }),
    {
      doInitialRequest: true,
    }
  )
  const { fetchData, loading: editingCarrierService } = useFetch(parcelServices.editParcel, {
    doInitialRequest: false,
  })
  const [showEditCarrierServiceModal, setShowEditCarrierServiceModal] = useState(false)

  const openEditCarrierServiceModal = () => {
    setShowEditCarrierServiceModal(true)
  }

  const closeEditCarrierServiceModal = () => {
    setShowEditCarrierServiceModal(false)
  }

  const onEditCarrierService = async carrierService => {
    const payload = { shipping_method: { carrier_service: carrierService } }

    try {
      await fetchData({ storeId, parcelId, payload })
      closeEditCarrierServiceModal(false)
      refetchParcel()
    } catch (error) {
      setToastInfo({ type: 'error', message: error.message })
    }
  }

  const allowEditCarrierService =
    !isTrackingParcel(parcel) &&
    [shipmentStatuses.requested, shipmentStatuses.packed, shipmentStatuses.ready].includes(parcel?.status)

  return {
    showEditCarrierServiceModal,
    carrierServices: carrierServices || [],
    onEditCarrierService,
    openEditCarrierServiceModal,
    closeEditCarrierServiceModal,
    loadingCarrierServices,
    editingCarrierService,
    allowEditCarrierService,
  }
}

export default useCarrierService
